import { render, staticRenderFns } from "./PhoneGallery.vue?vue&type=template&id=71ea20fc"
import script from "./PhoneGallery.vue?vue&type=script&lang=js"
export * from "./PhoneGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports